export default (
  <path
    d="M13.857 10.5078L21.1175 2.25H19.3976L13.0907 9.4187L8.0571 2.25H2.25L9.86345 13.0914L2.25 21.7499H3.9699L10.6259 14.1779L15.9429 21.7499H21.75M4.59065 3.51904H7.2329L19.3964 20.5432H16.7534"
    fill="currentColor"
  />
);
